<template>
    <glass-panel
        :class="['kpi-card', 'pa-6', clickable ? 'cursor-pointer' : null]"
        radius="md"
        style="position:relative;overflow:hidden"
        v-on="$listeners"
    >
        <div class="d-flex justify-space-between align-start mb-3" style="gap:8px">
            <eyebrow>
                <slot name="label">{{ label }}</slot>
            </eyebrow>

            <slot name="badge" />
        </div>

        <div class="d-flex align-baseline mb-4" style="gap:8px">
            <span :class="['kpi-number', highlight ? 'text-violet' : null]">
                <slot name="value">{{ value }}</slot>
            </span>
            <span
                v-if="$slots.suffix || suffix"
                class="body-xs text-muted"
            >
                <slot name="suffix">{{ suffix }}</slot>
            </span>
        </div>

        <div
            v-if="$slots.visual"
            class="kpi-card__visual"
        >
            <slot name="visual" />
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'KpiCard',
    props: {
        label: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        suffix: {
            type: String,
            default: '',
        },
        highlight: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
